import axios from "axios";
import RefreshTokenService from "./RefreshTokenService";

const getHostName = () => process.env.REACT_APP_HOST_NAME_BACKEND;

const axiosClient = axios.create({
  baseURL: `${getHostName()}/api/v1/`,
  withCredentials: true
});

let refreshPromise = null;

axiosClient.interceptors.response.use(
  response => response,
  async (error) => {
    const originalRequest = error?.config;
    const status = error?.response?.status;
    const url = originalRequest?.url || "";
    // Не намагаємось рефрешити для самих auth-ендпоінтів
    const isAuthPath = typeof url === "string" && (
      url.includes("/auth/login") ||
      url.includes("/auth/signup") ||
      url.includes("/auth/google") ||
      url.includes("/auth/refresh")
    );
    if (status === 401 && originalRequest && !originalRequest.__isRetryRequest && !isAuthPath) {
      // Ініціюємо/повторно використовуємо спільний рефреш-проміс
      if (!refreshPromise) {
        refreshPromise = RefreshTokenService.performTokenRefresh()
          .catch(async (e) => {
            throw e;
          })
          .finally(() => {
            // Після завершення обнуляємо проміс (в наступному тіку)
            setTimeout(() => {
              refreshPromise = null;
            }, 0);
          });
      }
      // Повертаємо проміс, що спочатку чекає рефреш, а потім ретраїть оригінальний запит
      return refreshPromise.then(() => {
        originalRequest.__isRetryRequest = true;
        return axiosClient.request(originalRequest);
      });
    }
    if (error.response && error.response.status !== 401) {
      console.error(error);
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
